// Utils
import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import status from './utils/status'
import * as customer from './api/customer'
import { setFolio, getFolio } from './utils/cookies'

// Components
import Home from './views/Home'
import Layout from './views/Layout'
import TaskTrack from './views/task/Track'
import TaskOrders from './views/task/Orders'
import Chat from './views/chat/index'
import TaskDetail from './views/task/Detail'
import Templates from './views/templates'

// firebase
import ini from '@/firebase'
import 'firebase/remote-config'
import { fetchAndActivate, getRemoteConfig, getValue } from 'firebase/remote-config'

const remoteConfig = getRemoteConfig(ini)
remoteConfig.settings.minimumFetchIntervalMillis = 3600000

Vue.use(Router)

function getFolioData(to, from, next) {
  let _params = null
  if (to.query && to.query.ws) {
    _params = to.query.ws
  }
  const folio = to.params.folio ? to.params.folio : to.query.folio
  customer.getFolio(folio, _params).then(async res => {
    if (res.rates === null) {
      res.rates = undefined
    }
    res.customIndicators = {}
    if ((status.cancelled.includes(res.orderStep)) && to.name === 'detail') {
      next(`/`)
      return
    }
    try {
      await workspaceCustom(res.workspace._id)
    } catch (error) {
      console.log('REMOTE_CONFIG_WS_CUSTOM_ERROR', error)
    }
    store.commit('NOTIFICATIONS_DATA', res.ETAAlerts)
    store.commit('SET_ORDER', res)
    setFolio(to.params.folio)
    next()
  }).catch(() => {
    next('/')
  })
}

async function workspaceCustom(wsId) {
  await fetchAndActivate(remoteConfig).then(() => {
    const val = getValue(remoteConfig, `ws_${wsId}`)
    const wsCustom = JSON.parse(val._value)
    store.commit('CUSTOM_WS', wsCustom)
  }).catch((err) => {
    console.log('REMOTE_CONFIG_ERROR', err)
  })
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Layout,
      beforeEnter: (to, from, next) => {
        var folio = getFolio()
        if (folio) {
          store.commit('FOLIO', folio)
        }
        store.commit('TO_HOME', false)
        next()
      },
      children: [
        {
          path: '/',
          name: 'home',
          component: Home
        }
      ]
    },
    {
      path: '/folio/:folio',
      name: 'folio',
      component: Layout,
      beforeEnter: async(to, from, next) => {
        const outOfService = JSON.parse(process.env.VUE_APP_OUT_OF_SERVICE)
        if (outOfService) {
          next('/')
          return
        }
        if (from.name === null) {
          store.commit('TO_HOME', true)
        }
        if (!store.getters.token) {
          const _params = {
            folio: to.params.folio,
            ws: to.query.ws
          }
          await store.dispatch('GetAuthTokenByFolio', _params).then(() => {
            getFolioData(to, from, next)
          }).catch(() => {
            next('/')
          })
          return
        } else {
          getFolioData(to, from, next)
        }
      },
      children: [
        {
          path: '/folio/:folio',
          name: 'task',
          component: Templates
        },
        {
          path: '/folio/:folio/detail',
          name: 'detail',
          component: TaskDetail,
          beforeEnter: function(to, from, next) {
            if (from.name) {
              store.commit('TO_HOME', false)
            }
            if (status.inProgres.includes(store.getters.order.orderStep)) {
              next(`/folio/${store.getters.order.folio}`)
            } else {
              next()
            }
          }
        },
        {
          path: '/folio/:folio/track',
          name: 'track',
          component: TaskTrack,
          beforeEnter: function(to, from, next) {
            if (from.name) {
              store.commit('TO_HOME', false)
            }
            if (status.object.TRANSIT === store.getters.order.orderStep) {
              next()
            } else {
              next({ path: `/folio/${to.params.folio}`, query: to.query })
            }
          }
        }
      ]
    },
    {
      path: '/chat',
      name: 'chat',
      component: Layout,
      beforeEnter: async(to, from, next) => {
        const outOfService = JSON.parse(process.env.VUE_APP_OUT_OF_SERVICE)
        if (outOfService) {
          next('/')
          return
        }
        if (from.name === null) {
          store.commit('TO_HOME', true)
        }
        if (to.query.folio) {
          if (!store.getters.token) {
            const _params = {
              folio: to.query.folio,
              ws: to.query.ws
            }
            await store.dispatch('GetAuthTokenByFolio', _params).then(() => {
              getFolioData(to, from, next)
            }).catch(() => {
              next('/')
            })
            return
          } else {
            getFolioData(to, from, next)
          }
        } else {
          next()
        }
      },
      children: [{
        path: '/chat',
        name: 'Chat',
        component: Chat
      }]
    },
    {
      path: '/orders',
      name: 'orders',
      component: Layout,
      children: [{
        path: '/orders',
        name: 'TaskOrders',
        component: TaskOrders
      }]
    }
  ]
})
